module.exports = __webpack_public_path__ + "img/ys3.50791d72.png";